import React, {useEffect} from "react";
import SeoImage from "../../assets/images/image-seo.jpg";
import {Helmet} from "react-helmet";
import {FormQuery} from "./FormQuery";
import {useNavigate} from "react-router-dom";
import {ListUser} from "./ListUser";
import {useSelector} from "react-redux";
import {selectEduType, selectUserId, selectVillageId} from "../../redux/slices/appSlice";
import {ENUM_ACCOUNT_TYPE} from "../../common/Constants";
import {ClientRequest} from "../../common/ClientRequest";
import {getToken} from "../../common/Storage";
import {useAppSelector} from "../../redux/hooks";
import {toast} from "react-toastify";

export const RankingsPage: React.FC = () => {
    const navigate = useNavigate();

    const selEduType = useSelector(selectEduType);
    const selUserId = useSelector(selectUserId);
    const selVillageId = useAppSelector(selectVillageId);

    const [isRequesting, setIsRequesting] = React.useState<boolean>(false);
    const [formData, setFormData] = React.useState<any>();
    const [rawDataTable, setRawDataTable] = React.useState<any>();
    const [searchValue, setSearchValue] = React.useState<{
        userId?: number,
        fullName?: string,
        schoolName?: string
    }>();

    useEffect(() => {
        if (selVillageId !== undefined) {
            if (selVillageId !== 1) {
                navigate("/", {replace: true});
                toast.error("Tài khoản của bạn không nằm trong danh sách được tham gia!");
            }
        }
    }, [selVillageId])
    useEffect(() => {
        if (formData) {
            handleGetList();
        }
    }, [formData])

    const handleGetList = async (pageIndex: number = 1, userId?: number, fullName?: string, schoolName?: string, pageSize: number = 50) => {
        setIsRequesting(true);
        try {
            const {code, data, message} = await ClientRequest("/ioe-service/v2/report/BaVi/StaticRank", {
                api_key: "string",
                examCode: formData?.round,
                serviceCode: "IOE",
                roundExam: formData?.round_1,
                block: formData?.block,
                schoolNameSeach: schoolName || "",
                userIdSearch: userId || 0,
                fullNameSearch: fullName || "",
                pageIndex: pageIndex,
                pageSize: pageSize,
                userId: selUserId,
                token: getToken(),
                IPClient: "string",
                deviceId: "string",
                sign: "string",
                deltatime: 0,
                redirectUrl: "string"
            });
            if (code === 0) {
                setRawDataTable(data);
            } else {
                setRawDataTable({message: message});
                // toast.error(message);
            }
        } catch (e) {
            console.error(e);
        } finally {
            setIsRequesting(false);
        }
    }
    const handleSearch = async (page: number, userId?: number, fullName?: string, schoolName?: string) => {
        if (!isRequesting) {
            setSearchValue({userId: userId, fullName: fullName, schoolName: schoolName});
            handleGetList(page, userId, fullName, schoolName);
        }
    }

    return (
        <>
            {/*@ts-ignore*/}
            <Helmet>
                <title>Cuộc thi Ngôi Sao Tiếng Anh</title>
                <meta property="title" content="Cuộc thi Ngôi Sao Tiếng Anh"/>
                <meta name="description"
                      content="Cuộc thi được tổ chức nhằm đáp ứng nhu cầu nâng cao năng lực tiếng Anh, đặc biệt là kỹ năng nói cho học sinh trên địa bàn huyện Ba Vì."/>
                <meta property="article:author" content="VTCOnline"/>
                <meta name="keywords" content=""/>
                <meta property="og:title" content="Cuộc thi Ngôi Sao Tiếng Anh"/>
                <meta property="og:url" content="https://edu.go.vn/ngoi-sao-tieng-anh-ba-vi"/>
                <meta property="og:type" content="website"/>
                <meta property="og:image" content={SeoImage}/>
                <meta property="og:description"
                      content="Cuộc thi được tổ chức nhằm đáp ứng nhu cầu nâng cao năng lực tiếng Anh, đặc biệt là kỹ năng nói cho học sinh trên địa bàn huyện Ba Vì."/>
            </Helmet>
            <div className={"xl:max-w-[1200px] mx-auto px-4 pt-6 min-h-screen"}>
                {/*<Breadcrumb
                    separator={"›"}
                    items={
                        [
                            {title: "Giới thiệu chung", path: "/"},
                            {title: "Bảng xếp hạng", path: ROUTER_PATHS.RANKINGS}
                        ]
                    }
                    itemRender={(route) => {
                        const isActive = route.path === location.pathname;
                        return <span className={isActive ? "text-[#0095DA]" : "cursor-pointer text-[#252525]"}
                                     onClick={() => {
                                         if (!isActive) {
                                             navigate(route.path as string);
                                         }
                                     }}>{route.title}</span>
                    }}
                />*/}
                <h1 className={"text-center text-[2rem] uppercase font-bold text-[#0095DA] pt-4"}>
                    {selEduType === ENUM_ACCOUNT_TYPE.EduManager_Phong ? "Bảng xếp hạng ngôi sao tiếng anh" : "Top 50 ngôi sao tiếng anh"}
                </h1>
                <FormQuery isRequesting={isRequesting}
                           onChange={() => setRawDataTable(undefined)}
                           onQuery={formData => {
                               setSearchValue(undefined);
                               setTimeout(() => setFormData(formData), 500)
                           }}/>
                <ListUser isRequesting={isRequesting}
                          round1={formData?.round_1}
                          searchValue={searchValue}
                          rawDataTable={rawDataTable}
                          onSearch={handleSearch}/>
            </div>
        </>
    );
}
